<script lang="ts">
  import { sectionForPath } from "./lib/nav-sections";
  import { startActionStream } from "./lib/actions.svelte";
  import { startAcInfinity } from "./lib/acinfinity-summary.svelte";
  import { startAdguardSummary } from "./lib/adguard-summary.svelte";
  import { startAgentsSummary } from "./lib/agents-summary.svelte";
  import { startAktorenSummary } from "./lib/aktoren-summary.svelte";
  import { startAmbient } from "./lib/ambient-summary.svelte";
  import { startAutomationsSummary } from "./lib/automations-summary.svelte";
  import { startClimateDevices } from "./lib/climate-devices.svelte";
  import { startClusterStats } from "./lib/cluster-stats.svelte";
  import { startTopologySummary } from "./lib/topology-summary.svelte";
  import { startLinkState } from "./lib/link-state.svelte";
  import { startCo2Summary } from "./lib/co2-summary.svelte";
  import { startDnsHealth } from "./lib/dns-health.svelte";
  import { startUptimeSummary } from "./lib/uptime-summary.svelte";
  import { startDockerSummary } from "./lib/docker-summary.svelte";
  import { startEnergySummary } from "./lib/energy-summary.svelte";
  import { startEsphomeSummary } from "./lib/esphome-summary.svelte";
  import { startFilesSummary } from "./lib/files-summary.svelte";
  import { startHostsSummary } from "./lib/hosts-summary.svelte";
  import { startLightningSummary } from "./lib/lightning-summary.svelte";
  import { startLipoguardSummary } from "./lib/lipoguard-summary.svelte";
  import { startLogsSummary } from "./lib/logs-summary.svelte";
  import { startNetworkDetails } from "./lib/network-details.svelte";
  import { startNetworkSummary } from "./lib/network-summary.svelte";
  import { startDrucker } from "./lib/drucker-summary.svelte";
  import { startProbeLive } from "./lib/backup-probe.svelte";
  import { startClaude } from "./lib/claude-summary.svelte";
  import { startArgus } from "./module/argus/argus.svelte";
  import { startStorageDetails } from "./lib/storage-details.svelte";
  import { startStorageSummary } from "./lib/storage-summary.svelte";
  import { startTasksList } from "./lib/tasks-list.svelte";
  import { startTasksSummaryStream } from "./lib/tasks-summary.svelte";
  import { startCriticalSummaryStream } from "./lib/critical-summary.svelte";
  import { startHeartbeat } from "./lib/heartbeat.svelte";
  import { startToolsSummary } from "./lib/tools-summary.svelte";
  import { startVaultSummary } from "./lib/vault-summary.svelte";
  import { startVaultInbox } from "./lib/vault-inbox.svelte";
  import { startWan } from "./lib/wan-summary.svelte";
  import { startNetzfrequenz } from "./lib/netzfrequenz-summary.svelte";
  import { startWaterleakSummary } from "./lib/waterleak-summary.svelte";
  import { startWeatherSummary } from "./lib/weather-summary.svelte";
  import { startZigbeeSummary } from "./lib/zigbee-summary.svelte";
  import { startZwaveSummary } from "./lib/zwave-summary.svelte";
  import LoginGate from "./lib/LoginGate.svelte";
  import MobileTabBar from "./lib/MobileTabBar.svelte";
  import { getJSON } from "./lib/api";
  import { startMediaJobsStream } from "./lib/media-jobs.svelte";
  import JobToastsPanel from "./lib/JobToastsPanel.svelte";
  import RekeyWindowIndicator from "./lib/RekeyWindowIndicator.svelte";
  import PushApprovalBanner from "./lib/PushApprovalBanner.svelte";
  import PushHealthBanner from "./lib/PushHealthBanner.svelte";
  import { startEntityDisables } from "./lib/entity-disables.svelte";
  import { startFreshness } from "./lib/freshness.svelte";
  import { startIntegrations } from "./lib/integrations.svelte";
  import { startI18n, t } from "./lib/i18n.svelte";
  import { reloadForBrokenChunk } from "./lib/pwa.svelte";
  import { ladeNeu, meldeStart } from "./lib/neuladen";
  import { installiereAnmeldeWache } from "./lib/anmeldung-wache";
  import { startRevalidationWatch } from "./lib/revalidate.svelte";
  import TopBar from "./lib/TopBar.svelte";
  import SiteFooter from "./lib/SiteFooter.svelte";
  import { startKlimaSummary } from "./lib/klima-summary.svelte";
  import { getPageNav } from "./lib/page-nav.svelte";
  import { setPageHeader } from "./lib/page.svelte";
  import { istDunkel } from "./lib/theme.svelte";
  import { startSecurityStream } from "./lib/security.svelte";
  import { startBypassSummary } from "./lib/bypass-summary.svelte";
  import { startAlertsStream } from "./lib/alerts-store.svelte";
  import { startEventsSummary } from "./lib/events-summary.svelte";
  import {
    activeSessions,
    subscribeSessionRegistry,
    type TerminalSession,
  } from "./lib/terminal-sessions";
  import ToastStack from "./lib/ToastStack.svelte";
  import Shell from "./lib/shell/Shell.svelte";
  import AnordnungsWirt from "./lib/AnordnungsWirt.svelte";
  import MobileTabSheet from "./lib/shell/MobileTabSheet.svelte";
  import PinAnfrage from "./lib/PinAnfrage.svelte";
  import { registerAllPanels } from "./lib/shell/panels";
  import { navigate, router } from "./lib/router.svelte";
  import { findRedirect, findRoute, prefetchAllPages, semanticIndexEntries } from "./lib/routes";
  import { einstellungenIndex } from "./lib/einstellungen/manifest";
  import { untrack, type Component } from "svelte";
  import {
    addEntities as semanticAddEntities,
    initSemantic,
    isAvailable as semanticAvailable,
    isReady as semanticReady,
  } from "./lib/semantic-search.svelte";
  import {
    inventoryEmbedEntries,
    startInventoryIndex,
  } from "./lib/inventory-index.svelte";
  import { startSearchLearn } from "./lib/search-learn-store.svelte";
  import { loadPrefsFromServer, markierePrefsGeladen, setzeGeraet } from "./lib/prefs.svelte";
  import { setSessionUserID } from "./lib/session.svelte";
  import { startBgLayers } from "./lib/bg-layers";
  import { syncThemeColor } from "./lib/bg-settings";

  // Tab-Typen einmalig anmelden (docs/shell.md). Muss vor dem ersten
  // oeffneTab() passiert sein -- ein unbekannter Typ ist dort ein
  // harter Fehler, kein leerer Tab.
  registerAllPanels();

  // Schreibtisch oder Telefon. Die Shell ist Schreibtisch-Denke; auf
  // dem Telefon steht ein eigenes Bedienkonzept an (Status sehen, Licht
  // schalten), bis dahin laeuft dort die heutige Navigation weiter.
  // 900 px ist dieselbe Grenze, die die Arbeitsflaeche fuer "keine zwei
  // Spalten" benutzt -- eine Zahl, nicht zwei.
  let schmal = $state(window.matchMedia("(max-width: 900px)").matches);
  $effect(() => {
    const mq = window.matchMedia("(max-width: 900px)");
    const anwenden = () => (schmal = mq.matches);
    anwenden();
    mq.addEventListener("change", anwenden);
    return () => mq.removeEventListener("change", anwenden);
  });

  // Auth-Gate: Status einmal beim Boot ziehen. Ist der User nicht
  // eingeloggt, rendern wir LoginGate statt der Routen + Streams.
  // Die Streams (Action/Security/Klima/...) laufen sonst gegen 401
  // und ueberfluten die Konsole. Erst nach erfolgreichem Auth werden
  // sie gestartet.
  type AuthStatus = {
    auth_required: boolean;
    authenticated?: boolean;
    user_id?: number;
    /** Das Gerät dieser Sitzung (Liste „Angemeldete Geräte"). Fehlt bei
     *  einer Sitzung ohne Gerät (Debug-Sitzung von agent-verify). */
    device_id?: number;
  };
  let authChecked = $state(false);
  let authed = $state(false);
  // Fehlgeschlagene Abfragen von auth/status. Antwortet der Server nicht
  // (PWA geöffnet, während make deploy läuft), ist das KEIN „nicht
  // angemeldet": bis 21.10.2026 zeigte der catch dann die Anmeldemaske,
  // obwohl die Sitzung galt, und fragte nie wieder. Jetzt: neuer Versuch
  // mit wachsendem Abstand, bis der Server antwortet.
  let authVersuche = $state(0);
  async function pruefeAnmeldung(): Promise<void> {
    let s: AuthStatus;
    try {
      s = await getJSON<AuthStatus>("/v2-api/auth/status");
    } catch {
      authVersuche++;
      setTimeout(() => void pruefeAnmeldung(), Math.min(1000 * 2 ** (authVersuche - 1), 15_000));
      return;
    }
    authed = !s.auth_required || !!s.authenticated;
    // Prefs vom Server sync'en, sobald die UserID bekannt ist.
    // Cache ist schon hydratisiert (main.ts initPrefsFromCache),
    // hier kommen Server-Werte + WS-Subscribe oben drauf.
    if (authed && s.user_id) {
      setSessionUserID(s.user_id);
      // Tabs, Leisten und Hell/Dunkel folgen dem Gerät. Die Kennung
      // muss VOR dem Server-Stand stehen: der übernimmt danach, was
      // diesem Gerät noch fehlt (lib/prefs-geraet.ts).
      setzeGeraet(s.device_id ?? null);
      void loadPrefsFromServer(s.user_id);
    } else {
      // Kein Server-Sync in Sicht: die Wiederhersteller sofort
      // freigeben, sonst warten sie auf etwas, das nie kommt.
      markierePrefsGeladen();
    }
    authChecked = true;
    if (authed) {
      startBootStreams();
      // Geht die Anmeldung später verloren (widerrufen, abgelaufen),
      // lädt die Seite neu und landet damit in der Anmeldemaske -- statt
      // still alte Daten zu zeigen (lib/anmeldung-wache.ts).
      installiereAnmeldeWache(() => ladeNeu("abgemeldet"));
    }
  }
  void pruefeAnmeldung();

  function startBootStreams() {
    // Hintergrund-Layer (CSS-Dekor, lib/bg-layers.ts). Hier statt in
    // main.ts, damit die Login-Seite kein persoenliches Theme zeigt und
    // beim First-Paint kein Dashboard-Hintergrund durch das noch leere
    // #app-Element scheint. Idempotent -- spaetere Aufrufe sind no-op.
    startBgLayers();
    // Action-Stream = Backend-Quelle fuer "was passiert gerade" (Reboots,
    // Container, Zigbee-Toggles); reconnect automatisch.
    startActionStream();
    // Media-Jobs-Indikator unten rechts -- entkoppelt von Page-Mounts.
    startMediaJobsStream();
    // Security-Stream: Dashboard-Card + Toasts auf fail2ban-Bans.
    startSecurityStream();
    // Bypass-Summary: Warn-Banner + TopBar-Schloss, solange der
    // Local-API-Bypass (Auth-Umgehung) aktiv ist.
    startBypassSummary();
    // Klima-Summary speist Dashboard + /zuhause/sensoren auch ohne
    // direkten Page-Besuch.
    startKlimaSummary();
    // Aktoren-Summary speist Dashboard + /zuhause/aktoren.
    startAktorenSummary();
    // Infrastruktur-Summaries (Network/Docker/Backups) speisen die
    // Cluster-Infra-Karten ohne Page-Mount. Polling im Hintergrund,
    // damit /infra/cluster beim Aufruf bereits Zahlen hat statt
    // "lade..." anzuzeigen.
    startNetworkSummary();
    startDockerSummary();
    // 3D-Drucker: speist „läuft gerade" (Statusleiste, Baum) auf jeder
    // Seite, nicht nur auf /werkstatt/drucker.
    startDrucker();
    // Wiederherstellungsprobe: eine laufende Probe steht in „läuft gerade"
    // (Statusleiste, Baum, Telefon). Nur das WS-Abo -- ohne Lauf kommt
    // auf dem Kanal nichts.
    startProbeLive();
    // Claude-Chats: Baum, Marke an der Leiste und „läuft gerade" brauchen
    // den Stand auf jeder Seite (docs/claude.md).
    startClaude();
    // Argus-Modul (docs/argus-modul.md): Baum (offene Bilder, Stände) und
    // „läuft gerade" (Training auf RunPod) auf jeder Seite.
    startArgus();
    // Rohe Cluster-Stats: Backend liefert In-Memory, aber ohne SWR-Cache
    // sieht /infra/cluster und /infra/cluster/host/[id] beim Reload erst
    // "lade...". Store haelt Snapshot in localStorage + 10s-Polling im
    // Hintergrund, daher sofortiger First-Paint.
    startClusterStats();
    startTopologySummary();
    startLinkState();
    // Dashboard-Cards: alle Stores, die heute auf der Uebersicht
    // sichtbar sind (vorher in Dashboard.svelte gestartet, jetzt hier
    // zentral nach data-loading.md "Polling seit Auth-OK").
    startHostsSummary();
    startEnergySummary();
    startAutomationsSummary();
    startAmbient();
    startDnsHealth();
    startUptimeSummary();
    startWan();
    startNetzfrequenz();
    startStorageSummary();
    startWeatherSummary();
    startAgentsSummary();
    startTasksSummaryStream();
    startCriticalSummaryStream();
    startAlertsStream();
    startEventsSummary();
    startHeartbeat();
    // Tasks-Detailliste fuer /tasks: SWR, Laufzustand per Protokoll
    // (task.*.lauf) und WS-Subscribe auf task_overrides, damit die Page bei
    // Reload sofort die letzte Liste zeigt.
    startTasksList();
    // Entity-Disables: domain-uebergreifender Cache "diese Entitaet
    // ist stillgelegt". Gehoert in die erste Welle -- die Dashboard-
    // Karten faerben sich danach.
    startEntityDisables();
    // i18n-Translations vor den t()-Aufrufen der Komponenten.
    startI18n();
    // Warum die Seite (neu) kam, ins Server-Protokoll (lib/neuladen.ts).
    meldeStart();

    // --- Zweite Welle ---------------------------------------------------
    //
    // Detail-Stores fuer Seiten, die beim Boot NICHT auf dem Schirm sind.
    // Sie laufen weiter im Hintergrund (Direct-Links aus iOS-PWA-
    // Notifications sollen sofort paint statt "Lade..." zeigen), aber
    // nicht mehr in derselben Sekunde wie die sichtbaren Karten.
    //
    // Grund: der Browser haelt pro Host nur ~6 gleichzeitige
    // HTTP/1.1-Verbindungen offen. Am 23.08.2026 draengelten sich hier
    // 117 Anfragen durch dieses Nadeloehr -- selbst /v2-api/version
    // brauchte dadurch rund eine Sekunde, obwohl es 257 Byte liefert.
    // Der SWR-Snapshot deckt die Luecke, wie bisher.
    setTimeout(() => {
      startAdguardSummary();
      startCo2Summary();
      startLipoguardSummary();
      startWaterleakSummary();
      startVaultSummary();
      // Vault-Ablage: offene Dokumente + Index-Stand fuer die
      // Dashboard-Karte, WS-getrieben (docs/vault-ablage.md).
      startVaultInbox();
      startZwaveSummary();
      startZigbeeSummary();
      startEsphomeSummary();
      startLightningSummary();
      // Climate-Detail-Liste (Temperatur/Feuchte/Druck pro Sensor) fuer
      // /zuhause/sensoren/insight. Eigener Endpoint /v2-api/climate; klima-
      // summary ist nur das Aggregat fuer Karte + Sensoren-Page.
      startClimateDevices();
      // Storage-Detail-Snapshot (pools/datasets/disks) fuer /infra/storage.
      // storage-summary startet ihn schon in der ersten Welle (Dashboard-
      // Card rechnet daraus); REST einmal, danach Protokoll-Deltas.
      startStorageDetails();
      // Phase-2 SWR-Stores: rohe Detail-Listen fuer Pages die vorher
      // ad-hoc gefetcht haben. Endpunkte sind alle billig (Backend-Cache).
      startNetworkDetails();
      startAcInfinity();
      startFilesSummary();
      startToolsSummary();
      startLogsSummary();
      startFreshness();
      startIntegrations();
    }, 2000);
    // Semantic-Search: Embeddings fuer alle Routen vorrechnen
    // (cached in localStorage). Wenn der Inferenzdienst down ist, no-op und FE
    // faellt auf Fuzzy-Only zurueck. Hintergrund-Job, blockiert
    // nichts.
    void initSemantic(semanticIndexEntries());
    // Inventar-Index: laedt Tasks + Hosts (Automations/Agents kommen
    // aus den schon laufenden Stores). NavSearchPanel zieht das ab
    // und embedded es in die Suche -- damit "backup" auch wob-data-
    // backup findet, nicht nur die /tasks-Page.
    startInventoryIndex();
    // Adaptives Lernen (Schicht 2): haengt sich an die prefs-Keys
    // search_learn (State) + search_learn_config (Overrides) und
    // gibt NavSearchPanel reaktive bonusFor/frecentIds-Reader.
    startSearchLearn();
    // Tab-Refocus / Netz-zurueck: WS-Hub neu verbinden falls halb-tot +
    // alle registrierten Stores revalidieren, damit ein stundenlang
    // offener Tab nicht auf veralteten Zahlen haengt.
    //
    // Die Reihenfolge ist hier egal: registerRevalidator fuellt eine
    // Menge, die erst beim Ereignis durchlaufen wird -- die Stores der
    // zweiten Welle tragen sich zwei Sekunden spaeter ein und sind ab
    // dann genauso dabei.
    startRevalidationWatch();
    // Alle Page-Chunks im Hintergrund nachladen (Code-Splitting):
    // erst wenn der Boot-Burst der Stores durch ist, damit Navigation
    // danach wieder ohne Netz-Roundtrip instant ist.
    prefetchAllPages();
  }

  // Inventar in den semantischen Index nachschieben, sobald es da ist.
  //
  // Das stand frueher in NavSearchPanel -- und lief damit erst, wenn
  // jemand das Panel aufmachte. In der Shell mountet die Palette das
  // Panel erst bei nicht-leerer Eingabe: die ERSTE getippte Suche einer
  // Sitzung lief dadurch gegen einen halb leeren Index (gemessen am
  // 20.08.: 63 Texte nach dem Boot, die restlichen ~160 erst nach dem
  // ersten Tastendruck). Hier gilt es fuer beide Huellen und ist ein
  // paar Sekunden nach dem Login durch.
  //
  // untrack(): addEntities liest synchron `_embeddings`, um schon
  // Eingebettetes zu ueberspringen, und schreibt es spaeter -- ohne
  // untrack weckt der Effekt sich selbst (siehe docs/shell.md, dieselbe
  // Falle wie bei folgeSektion).
  $effect(() => {
    if (!semanticReady() || !semanticAvailable()) return;
    const entries = inventoryEmbedEntries();
    if (entries.length === 0) return;
    untrack(() => void semanticAddEntities(entries));
  });

  // Die Einstellungen in denselben Index: das Einstellungsfenster sucht
  // damit auch dem Sinn nach ("was kostet der Strom"). Beim Boot, aus
  // demselben Grund wie oben -- die erste Frage soll nicht gegen einen
  // leeren Index laufen. 47 kurze Texte, einmal gerechnet, danach aus
  // der Ablage (embedding-store).
  $effect(() => {
    if (!semanticReady() || !semanticAvailable()) return;
    untrack(() => void semanticAddEntities(einstellungenIndex()));
  });

  // Theme-Mode kommt aus dem geteilten Store (lib/theme.svelte.ts).
  // Settings-Page schreibt ihn (Auto/Hell/Dunkel-Buttons), App.svelte
  // ist der einzige Schreiber Richtung DOM/LocalStorage.
  const isDark = $derived(istDunkel());

  $effect(() => {
    document.documentElement.classList.toggle("dark", isDark);
    // Muss mit der Klasse mitlaufen: color-scheme faerbt die Canvas,
    // die der Browser VOR dem Stylesheet malt (siehe index.html). Bliebe
    // es beim Boot-Wert, blitzte es nach einem Theme-Wechsel beim
    // naechsten Reload in der alten Farbe.
    document.documentElement.style.colorScheme = isDark ? "dark" : "light";
    // Persistenz der Mode laeuft jetzt ueber lib/prefs.svelte
    // (Server-SSOT + localStorage-Cache + Multi-Device-Sync); App
    // pflegt nur noch die DOM-Side-Effects (CSS-Klasse, Safari-
    // Theme-Color-Meta). Die Meta-Farbe kommt aus --bg-bar
    // (Seiten-Bg Richtung Wash getoent) und haengt an der frisch
    // getoggleten .dark-Klasse.
    syncThemeColor();
  });

  // IA-Redirect: alte URLs aus dem `redirects`-Map (routes.ts) werden
  // beim Hash-Wechsel auf die neue Route umgeleitet, damit Bookmarks
  // nach IA-Refactors nicht brechen. Lauft vor findRoute, damit der
  // Page-Mount mit der finalen URL passiert (sonst flackert kurz die
  // alte Page bevor die neue rendert).
  $effect(() => {
    // Auf dem Schreibtisch macht das die Shell (route-sync.svelte.ts) --
    // zwei Schreiber auf derselben Adresszeile waeren ein Kampf.
    if (!schmal) return;
    const target = findRedirect(router.current);
    if (target) {
      // Query-Teil mitnehmen: alte Deeplinks wie /tasks?focus=<id>
      // sollen als /system/tasks?focus=<id> landen, nicht nackt.
      const raw = window.location.hash.replace(/^#/, "");
      const qIdx = raw.indexOf("?");
      navigate(qIdx >= 0 ? target + raw.slice(qIdx) : target);
    }
  });

  const matched = $derived(findRoute(router.current));
  const route = $derived(matched?.route ?? null);

  // Code-Splitting (2026-07): route.component ist ein Lazy-Loader,
  // kein Component mehr. Hier aufloesen; waehrend ein Chunk noch
  // laedt bleibt die vorige Page stehen (kein Flackern). Der
  // cancelled-Guard verwirft veraltete Aufloesungen, wenn schnell
  // weiternavigiert wird. Nach dem Idle-Prefetch (startBootStreams)
  // sind alle Chunks im Modul-Cache -> Aufloesung im Microtask.
  let Page = $state<Component | null>(null);
  // firstReady: erst true, wenn der ERSTE Page-Chunk aufgeloest ist (oder
  // die Route unbekannt = 404). Gate fuer den ersten Paint, damit beim
  // Oeffnen eines neuen Tabs nicht kurz die nackte Shell (TopBar ohne
  // Inhalt) blitzt, bevor der lazy Chunk da ist -- stattdessen zeigt sich
  // das Gesamtbild auf einmal. Einwegschalter: Folge-Navigation ist NICHT
  // betroffen (dort bleibt eh die alte Seite stehen, s.o.).
  let firstReady = $state(false);
  let loadFailed = $state(false);
  $effect(() => {
    const r = route;
    if (!r) {
      Page = null;
      firstReady = true;
      return;
    }
    let cancelled = false;
    loadFailed = false;
    r.component()
      .then((m) => {
        if (!cancelled) Page = m.default;
      })
      .catch((err) => {
        if (cancelled) return; // Nutzer ist laengst woanders
        // Chunk nicht ladbar -- in aller Regel ein Deploy waehrend offener
        // Sitzung (neue Hashes, alte Datei weg). Die App holt sich per
        // Reload die neue Shell (reloadForBrokenChunk, max 1x/30s).
        //
        // Page MUSS dabei fallen: sonst bleibt die vorherige Seite stehen,
        // waehrend Route + Breadcrumb schon die neue zeigen -- genau das
        // sieht aus wie "Page nicht aufrufbar" (Tim 15.07.: Automatisier-
        // ungen-Breadcrumb ueber Dashboard-Karten; home-dash b3ed0cd).
        // Und greift der Loop-Schutz, sagen wir es ehrlich, statt eine
        // leere Flaeche zu zeigen.
        Page = null;
        if (!reloadForBrokenChunk("seite: " + String(err))) loadFailed = true;
      })
      .finally(() => {
        if (!cancelled) firstReady = true;
      });
    return () => {
      cancelled = true;
    };
  });

  $effect(() => {
    router.params = matched?.params ?? {};
  });

  // Page-Header zuruecksetzen bei Route-Wechsel. setPageHeader wird
  // heute von keinem Layout-Element mehr gelesen (Breadcrumb in der
  // TopBar baut sich aus router.current + routes.ts), aber Pages
  // duerfen weiter setPageHeader aufrufen -- ein Reset beugt vor,
  // dass spaetere Konsumenten stale-Titel sehen.
  $effect(() => {
    router.current;
    setPageHeader("", "");
  });

  // page-nav nur fuer den wide-Modus (Files-Dual-Pane: max-w-480
  // statt max-w-6xl). Slots (back/actions/info) liest TopBar selbst.
  const nav = $derived(getPageNav());

  // Aktive Terminal-Sessions: Indikator unten rechts wenn
  // mindestens eine Session lebt, sodass Tim aus jeder Page direkt
  // zurueck springen kann. Wandert in Commit 6 in den Operations-
  // Store; bis dahin bleibt's ein eigenes Floating-Element.
  let liveTerminals = $state<TerminalSession[]>([]);
  $effect(() => {
    const sync = () => (liveTerminals = activeSessions());
    sync();
    return subscribeSessionRegistry(sync);
  });
</script>

<ToastStack />
<PinAnfrage />

{#if authChecked && authed}
  <PushApprovalBanner />
  <PushHealthBanner />
{/if}

{#if !authChecked && authVersuche > 0}
  <!-- auth/status antwortet nicht (Deploy, Netz): warten, nicht die
       Anmeldemaske zeigen -- die Sitzung kann gültig sein. -->
  <div class="grid place-items-center p-6" style="height: var(--app-vh, 100dvh);">
    <p class="text-fg-muted t-meta" role="status">{t("auth.boot.warte", "Server antwortet nicht · neuer Versuch …")}</p>
  </div>
{:else if authChecked && !authed}
  <LoginGate />
{:else if authChecked && !schmal}
  <!-- Schreibtisch: die Shell IST die App (docs/shell.md). Jeder
       Inhalt ist ein Tab, auch das Dashboard. -->
  <Shell />
{:else if authChecked}
  <!-- Telefon: heutige Navigation, bis das Mobil-Konzept steht.
       MobileTabSheet faengt die Tabs ab, die keine Seite sind. -->
  <MobileTabSheet />
<!-- Universal-Layout: TopBar oben mit Brand + Breadcrumb + integrierter
     Suche + Page-Tools. Die Suche ist Teil der Pille (kein eigenes
     Overlay mehr), Cmd-K/Rechtsklick fokussieren das Eingabefeld.
     Navigation laeuft komplett ueber die TopBar plus die Section-
     Overview-Pages. Wide-Pages (Files-Dual-Pane) duerfen via nav.wide
     auf max-w-480 erweitern.

     Hoehe ueber --app-vh (gepflegt von lib/viewport-sync.ts) statt
     h-dvh: iOS-Standalone-PWA meldet beim Cold-Start eine falsche dvh,
     dadurch sass die Tab-Bar zu hoch. visualViewport-API ist die
     verlaessliche Quelle, viewport-sync forciert die Korrektur ueber
     mehrere Timer + Scroll-Wackler + visibilitychange-Listener. Fallback
     100dvh fuer den allerersten Frame, bevor main.ts den Sync startet.

     Seit 22.10.2026 folgt die Huelle dem sichtbaren Ausschnitt GANZ
     (fixed, top = --app-vv-top): iOS schiebt beim Tippen die Seite unter
     der Tastatur nach oben, statt sie zu verkleinern -- ohne das rutschte
     das Eingabefeld aus dem Bild (viewport-sync.ts, Tastatur). -->
<div
  class="fixed inset-x-0 flex flex-col overflow-hidden transition-opacity duration-200 {firstReady
    ? 'opacity-100'
    : 'opacity-0'}"
  style="top: var(--app-vv-top, 0px); height: var(--app-vh, 100dvh);"
>

  <!-- Floating-Layer fuer Toast-Stream + Live-Terminal-Sprung. Der
       Datei-Verschiebungs-Indikator (MediaJobsPanel) sitzt jetzt in
       der TopBar-Pille, nicht mehr hier. top-Offset zieht safe-area
       mit, damit das Element auf iPhone PWA nicht unter Dynamic Island
       sitzt. -->
  <div
    class="pointer-events-none fixed z-40 flex items-center gap-1.5"
    style="top: calc(var(--sicher-oben) + 0.75rem); right: calc(env(safe-area-inset-right, 0px) + 1rem);"
  >
    <div class="pointer-events-auto">
      <JobToastsPanel />
    </div>
    <RekeyWindowIndicator />
    {#if liveTerminals.length > 0 && !router.current.startsWith("/system/terminal")}
      <a
        href="#/system/terminal"
        aria-label="Aktive Terminal-Session"
        title="Aktive Terminal-Session ({liveTerminals.length})"
        class="text-accent hover:bg-accent/10 pointer-events-auto relative flex h-7 w-7 items-center justify-center rounded-full transition"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <polyline points="4 17 10 11 4 5" />
          <line x1="12" y1="19" x2="20" y2="19" />
        </svg>
        {#if liveTerminals.length > 1}
          <span
            class="bg-accent text-accent-fg absolute -right-1 -top-1 flex h-3.5 min-w-3.5 items-center justify-center rounded-full px-1 text-[9px] font-bold leading-none tabular-nums"
          >
            {liveTerminals.length}
          </span>
        {/if}
      </a>
    {/if}
  </div>

  <main class="safe-area-shell content-top-fade @container/seite relative min-w-0 flex-1 overflow-x-clip overflow-y-auto">
      <!-- KEIN overflow-clip auf diesem Wrapper: das kappt den
           card-hover-Halo (box-shadow ~26px) hart am Container-Rand,
           und overflow-clip-margin greift bei gemischten Achsen
           (x:clip / y:visible) nicht zuverlaessig. Der Layout-Guard
           gegen lange Token sitzt auf <main> (min-w-0 + overflow-x-clip)
           -- das verhindert horizontales Scrollen der GANZEN Seite, der
           eigentliche "Layout sprengen"-Fall. -->
      <!-- Flex-Spalte fuer den Sticky-Footer. TopBar + Page in einem Block-
           Wrapper (flex-1), damit das mx-auto der TopBar wie im Block-Kontext
           wirkt (volle Breite) statt als Flex-Item zu schrumpfen. -->
      <div class="mx-auto flex min-h-full flex-col {nav.wide ? 'max-w-480' : 'max-w-360'}">
        <!-- data-bereich: die Seite erbt die Farbe ihres Bereichs (app.css
             „Farbe") -- am Schreibtisch setzt das die EditorArea. -->
        <div class="min-w-0 flex-1" data-bereich={sectionForPath(router.current)?.id}>
          <!-- Platzhalter fuer die schwebende TopBar (liegt jetzt als
               Overlay ausserhalb des maskierten Scrollports, s. unten).
               Hoehe = sticky top-2 (0.5rem) + h-12 (3rem) + mb-6 (1.5rem)
               = 5rem (h-20), damit der Seiteninhalt wie zuvor unter der
               Bar beginnt und die sticky Tabellen-Koepfe (top:3.5rem)
               weiter an der Bar-Unterkante parken. -->
          <div class="h-20" aria-hidden="true"></div>
          {#if route && Page}
            <!-- wie PageHost am Schreibtisch: Karten anordnen -->
            <AnordnungsWirt seite={route.path}>
              <Page />
            </AnordnungsWirt>
          {:else if !route}
            <div class="grid min-h-[40vh] place-items-center">
              <div class="text-fg-muted">404 — {router.current}</div>
            </div>
          {:else if loadFailed}
            <!-- Chunk weg UND der Reload-Loop-Schutz hat gegriffen: lieber
                 ein ehrlicher Hinweis mit Ausweg als eine leere Flaeche. -->
            <div class="grid min-h-[40vh] place-items-center">
              <div class="surface border-border rounded-xl border p-8 text-center">
                <p class="t-headline text-fg">{t("app.chunk_failed.title", "Seite konnte nicht geladen werden")}</p>
                <p class="t-meta text-fg-muted mt-2 max-w-sm">
                  {t("app.chunk_failed.body", "Meist liegt das an einem Update, das gerade ausgerollt wurde. Neu laden holt die aktuelle Version.")}
                </p>
                <button
                  type="button"
                  onclick={() => ladeNeu("knopf")}
                  class="border-accent/50 bg-accent text-accent-fg mt-4 rounded-lg border px-4 py-2 t-body font-medium transition hover:opacity-90"
                >
                  {t("app.chunk_failed.reload", "Neu laden")}
                </button>
              </div>
            </div>
          {/if}
        </div>
        <SiteFooter />
      </div>
    </main>

  <!-- TopBar als schwebendes Overlay ueber dem maskierten <main>.
       Bewusst AUSSERHALB des Scrollports: so zeichnet die content-top-fade-
       Maske (auf <main>) die Bar NICHT mit -- die Bar-Chrome bleibt
       gestochen scharf, waehrend der Inhalt darunter durchscrollt und sich
       zur Bar-Unterkante hin aufloest. KEIN z-index am Overlay, damit das
       TopBar-eigene Info-Modal (z-50) weiter ueber den Toasts (z-40) liegt;
       die Bar traegt ihr eigenes z-30. Nur die Bar selbst faengt Klicks
       (pointer-events), der Streifen daneben/darunter bleibt fuer den
       Inhalt durchlaessig. top + horizontale Polsterung + mx-auto/max-w
       spiegeln exakt die Spalte von <main> (safe-area-shell + top-2), damit
       die Bar deckungsgleich ueber dem Inhalt sitzt. -->
  <div
    class="pointer-events-none absolute inset-x-0"
    style="top: calc(max(1rem, var(--sicher-oben)) + 0.5rem); padding-left: max(1.5rem, env(safe-area-inset-left, 0px)); padding-right: max(1.5rem, env(safe-area-inset-right, 0px));"
  >
    <div class="mx-auto {nav.wide ? 'max-w-480' : 'max-w-360'} [&>header]:pointer-events-auto">
      <TopBar />
    </div>
  </div>

  <MobileTabBar />
</div>
{/if}
